"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPagePutBodyFromJSON = AdminPagePutBodyFromJSON;
exports.AdminPagePutBodyFromJSONTyped = AdminPagePutBodyFromJSONTyped;
exports.AdminPagePutBodyToJSON = AdminPagePutBodyToJSON;
exports.AdminPagePutBodyToJSONTyped = AdminPagePutBodyToJSONTyped;
const _1 = require("./");
function AdminPagePutBodyFromJSON(json) {
    return AdminPagePutBodyFromJSONTyped(json, false);
}
function AdminPagePutBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': (0, _1.AdminPageDataFromJSON)(json['data']),
    };
}
function AdminPagePutBodyToJSON(value) {
    return AdminPagePutBodyToJSONTyped(value, false);
}
function AdminPagePutBodyToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, _1.AdminPageDataToJSON)(value.data),
    };
}
